const COLORS = {
  PRIMARY: "primary",
};

const SIZES = {
  MEDIUM: "m",
};

export { COLORS, SIZES };
